import styled from 'styled-components';

import { theme } from '@notino/react-styleguide-v20';

import { FooterRow } from '@sharedComponents/FooterRow';
import { StyledCheckoutWrapper } from '@styles/generalStyles';

export const FixedWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${theme.color.background.primary};
  display: block;
  z-index: 100;
  box-sizing: border-box;
  padding-bottom: 0.5rem;
  padding-top: 1.25rem;
  box-shadow: 0 -0.125rem 0.25rem 0 ${theme.color.common.gray30}14;
`;

export const StyledPageFooterRow = styled(FooterRow)`
  margin-bottom: 2.125rem;
  margin-top: 1.25rem;
  padding-bottom: 1rem;
`;

export const StyledButtonWrapper = styled(StyledCheckoutWrapper)`
  padding-bottom: inherit;
`;
